import { CpmIconButton } from '../../../components/design-system';

function PencilIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </svg>
    );
}

export default function PencilButton({ label, onClick }: { label: string; onClick: () => void }) {
    return (
        <CpmIconButton
            icon={<PencilIcon />}
            label={label}
            size="sm"
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        />
    );
}
